import React, { useMemo, useState } from 'react';
import ScoreEvidenceModal from './ScoreEvidenceModal';

const parseDetails = (details) => {
  if (!details) return null;
  if (typeof details === 'string') {
    try {
      return JSON.parse(details);
    } catch {
      return null;
    }
  }
  if (typeof details === 'object') return details;
  return null;
};

const hasUsableDetails = (details) => {
  if (!details || typeof details !== 'object') return false;
  if (Array.isArray(details.criteria) && details.criteria.length > 0) return true;
  return details.total_score !== undefined || details.weights || details.components;
};

const ScoreDetailsInfo = ({ details, className = '', candidateName = 'Candidate', title = 'Resume Match Details' }) => {
  const [open, setOpen] = useState(false);

  const parsedDetails = useMemo(() => parseDetails(details), [details]);

  if (!hasUsableDetails(parsedDetails)) return null;

  return (
    <span className={`inline-flex ${className}`} onClick={(event) => event.stopPropagation()}>
      <button
        type="button"
        aria-label="View resume match details"
        title="View resume match details"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-gray-300 bg-white text-[11px] font-bold text-gray-500 shadow-sm transition hover:border-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300"
      >
        i
      </button>
      <ScoreEvidenceModal
        open={open}
        onClose={() => setOpen(false)}
        candidate={{
          name: candidateName || 'Candidate',
          score_details: parsedDetails,
          match_percentage: parsedDetails?.total_score,
        }}
        title={title}
        scoreKind="resume_match"
      />
    </span>
  );
};

export default ScoreDetailsInfo;
